import { Box, Typography } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { getCalendarDays, getWeekdays } from "../utils/calendarUtils";
import DayCell from "./DayCell";
import OutOfMonthDayCell from "./OutOfMonthDayCell";
import { useMemo } from "react";
import { useAvailabilities } from "../AvailabilitiesProvider";

interface AvailabilitiesCalendarProps {
  selectedDate: Dayjs;
}

export default function AvailabilitiesCalendar({
  selectedDate,
}: AvailabilitiesCalendarProps) {
  const { getAvailabilitiesForDate } = useAvailabilities();
  const daysOfWeek = getWeekdays("ddd");
  const days = useMemo(() => getCalendarDays(selectedDate), [selectedDate]);
  return (
    <Box>
      <Box
        width="100%"
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(7, minmax(0, 1fr))",
          gap: 0,
          backgroundColor: "#F6F7F9",
        }}
      >
        {daysOfWeek.map((day) => (
          <Typography
            key={day}
            variant="body2"
            sx={{
              fontWeight: 600,
              textAlign: "center",
              color: "#666",
              p: 1,
              maxWidth: "220px",
              flexShrink: 0,
            }}
          >
            {day}
          </Typography>
        ))}
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(7, minmax(0, 1fr))",
          gap: 0,
        }}
      >
        {days.map((day) => {
          const isCurrentMonth = day.month() === selectedDate.month();
          const isToday = day.isSame(dayjs(), "day");
          if (!isCurrentMonth) {
            return (
              <OutOfMonthDayCell key={day.format("YYYY-MM-DD")} day={day} />
            );
          }
          return (
            <DayCell
              key={day.format("YYYY-MM-DD")}
              day={day}
              isToday={isToday}
              availabilities={getAvailabilitiesForDate(day.format("YYYY-MM-DD"))}
            />
          );
        })}
      </Box>
    </Box>
  );
}
